import {
  Badge,
  BadgeProps,
  Grid,
  GridProps,
  ListItem,
  Typography,
  type TypographyProps
} from '@mui/material'
import React from 'react'

export const TutorialStep: React.FC<
  {
    title: string
    titleProps?: TypographyProps
    badgeNumber?: number
    badgeProps?: BadgeProps
  } & GridProps
> = ({ title, titleProps, badgeNumber, badgeProps, children, ...rest }) => {
  return (
    <ListItem disablePadding>
      <Grid
        container
        data-testid={`prepare-to-define-services-tutorial-step-${badgeNumber}`}
        direction="row"
        spacing={2}
        sx={{ ml: 1, mt: 2 }}
        {...rest}
      >
        <Grid item mt={0.3}>
          <Badge
            badgeContent={badgeNumber}
            color="tutorialStep"
            {...badgeProps}
          />
        </Grid>
        <Grid item xs={11}>
          <Typography
            color="tutorialStep.main"
            data-testid={`prepare-to-define-services-tutorial-step-${badgeNumber}-title`}
            variant="h6"
            {...titleProps}
          >
            {title}
          </Typography>
          {children}
        </Grid>
      </Grid>
    </ListItem>
  )
}
